import { Link } from "react-router-dom";
import { Phone, MessageCircle } from "lucide-react";
import { PHONE_TEL, waLink, DEFAULT_WA_MSG } from "../data/site";

export default function NotFound() {
  return (
    <div className="min-h-[70vh] flex flex-col items-start justify-center max-w-7xl mx-auto px-5 sm:px-8 pt-32 pb-24" data-testid="not-found-page">
      <p className="font-telemetry text-xs uppercase tracking-[0.3em] text-[#FF5500] mb-4">404</p>
      <h1 className="font-display font-extrabold uppercase text-5xl sm:text-7xl leading-[0.95]">
        This road
        <br />
        <span className="text-outline">doesn't exist.</span>
      </h1>
      <p className="mt-5 text-zinc-400 max-w-md">
        The page you're after has gone flat. Head back home — or call dispatch
        and we'll get you moving.
      </p>
      <div className="mt-8 flex flex-col sm:flex-row gap-3">
        <Link
          to="/"
          data-testid="not-found-home-link"
          className="btn-glow px-8 py-4 rounded-full bg-[#FF5500] text-black font-telemetry text-sm font-semibold uppercase tracking-[0.12em] text-center"
        >
          Back to home
        </Link>
        <a
          href={PHONE_TEL}
          data-testid="not-found-call-button"
          className="flex items-center justify-center gap-2 px-8 py-4 rounded-full border border-[#27272A] text-zinc-200 font-telemetry text-sm uppercase tracking-[0.12em]"
        >
          <Phone className="w-4 h-4 text-[#FF5500]" /> Call dispatch
        </a>
        <a
          href={waLink(DEFAULT_WA_MSG)}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="not-found-whatsapp-button"
          className="flex items-center justify-center gap-2 px-8 py-4 rounded-full border border-emerald-500/60 text-emerald-400 font-telemetry text-sm uppercase tracking-[0.12em]"
        >
          <MessageCircle className="w-4 h-4" /> WhatsApp
        </a>
      </div>
    </div>
  );
}
